<script>
import Price from '@wielink-application/shared/vue/components/form/horizontal/price.vue'

export default Price;
</script>